import { useEmployeeSession } from "./employeeSession";

export type UserData = Record<string, any> | null;

export const useUserSession = useEmployeeSession;
